/**
 * Determines whether a plan change constitutes a downgrade.
 * A downgrade is detected when a previously active service is removed
 * OR when the new monthly recurring total is less than the current one.
 */
export function isDowngradeChange({ previousServiceIds, currentServiceIds, previousMonthlyTotal, newMonthlyTotal }) {
  const currentSet = currentServiceIds instanceof Set
    ? currentServiceIds
    : new Set(currentServiceIds)

  const hasServiceRemoved = (previousServiceIds || []).some(id => !currentSet.has(id))
  const hasPriceDropped = (Number(newMonthlyTotal) || 0) < (Number(previousMonthlyTotal) || 0)

  return hasServiceRemoved || hasPriceDropped
}
